import { Component, OnInit, HostListener } from '@angular/core';
import { isODM } from '../../../environments/environment';
import { WindowService } from '../../services/window.service';
import * as fromStore from '../../store';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PackageList, urlPath } from '../../shareModel';

@Component({
  standalone: false,
  selector: 'app-help-header',
  templateUrl: './help-header.component.html',
  styleUrls: ['./help-header.component.css']
})
export class HelpHeaderComponent implements OnInit {
  logoPath: any;
  hostName: string;
  helpSidebar;
  powerMaster = isODM;
  windowScrolled: boolean;
  shareModel = {
    PackageList: PackageList,
    urlPath: urlPath
  };
  private componentDestroyed = new Subject();
  constructor(private store: Store<fromStore.State>, private windowService: WindowService) {
    // Get HostName & Region Info For Logo Path
    this.hostName = this.windowService.getHostName();
    this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.length > 0) {
        const region = this.windowService.getLogoRegion(res);
        if (typeof region !== 'undefined' && region !== null) {
          this.logoPath = region.Note;
        }
        // const logoPath = res.find(i => i.Region.toLowerCase() === this.hostName.toLowerCase());
        // if (typeof logoPath !== 'undefined' && logoPath !== null) {
        //   this.logoPath = logoPath.Note;
        // }
      }
    });

  }
  @HostListener('window:scroll', ['$event']) onWindowScroll(e) {
    if (window.pageYOffset > 100) {
      this.windowScrolled = true;
    } else {
      this.windowScrolled = false;
    }
  }
  @HostListener('window:resize', ['$event'])

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-help');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    this.logoPath = this.windowService.getLogoPath();

    if (innerWidth > 1024 && innerWidth < 1367) {
      this.helpSidebar = false;
    } else {
      this.helpSidebar = false;
    }
  }

  scrollToElement($element, margin = 90): void {
    const dims = $element.getBoundingClientRect();
    const y = dims.top - margin;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  onResize(event) {
    if (event.target.innerWidth > 1024) {
      this.helpSidebar = false;
    } else if (event.target.innerWidth < 1024) {
      this.helpSidebar = false;
    }

  }
}
